












import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { Role } from '@/core/security/Role';

import bus from '@/core/bus';
import { BusConstants } from '@/core/constants';

@Component
export default class PermissionsValidator extends Vue {
	@Prop() permissions!: string[];
	@Prop() roles!: Role[];

	canAccessComponent: boolean = false;

	ValidateComponentAccess() {
	    const permissionsValidated = this.permissions ? !!UserModule.user?.HasPermission(this.permissions) : true;
	    const rolesValidated = this.roles ? !!UserModule.user?.HasRole(this.roles) : true;
	    this.canAccessComponent = permissionsValidated && rolesValidated;
	}

	mounted() {
	    this.ValidateComponentAccess();
	}

	created() {
	    bus.on(BusConstants.SelectedRealmChanged, this.ValidateComponentAccess);
	}

	destroyed() {
	    bus.off(BusConstants.SelectedRealmChanged, this.ValidateComponentAccess);
	}
}
